export default __webpack_public_path__ + "static/media/work-content.9d9c8b6d.jpeg";